import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { AcompanheRedesSection } from 'volto-ministerio-publico-federal/components/View/CapaView/AcompanheRedesSection';
import {
  redesHasContent,
  type RedesData,
} from 'volto-ministerio-publico-federal/components/View/CapaView/helpers';

interface MpfAcompanheRedesBlockViewProps {
  data: RedesData;
  /** Presente só no editor: o slot do card em que se clicou o lápis. */
  onEditItem?: (slot: number) => void;
}

const EMPTY_TEXT =
  'Sem posts cadastrados. Cole a URL de um post para a faixa aparecer na capa.';

/** Bloco "Acompanhe nossas redes (capa)". */
const MpfAcompanheRedesBlockView = ({
  data,
  onEditItem,
}: MpfAcompanheRedesBlockViewProps) => {
  if (!redesHasContent(data)) {
    return (
      <section className="rounded-md border border-dashed border-gray-300 p-4 dark:border-night-850">
        <h2 className="text-lg font-semibold text-on-surface dark:text-night-100">
          Acompanhe nossas redes
        </h2>
        <p className="mt-1 text-sm text-gray-500 dark:text-night-400">
          {data?.placeholder || EMPTY_TEXT}
        </p>
      </section>
    );
  }

  /* `isEditMode={!!onEditItem}`, e não cravado em `true`: só o `Edit.tsx` passa
     `onEditItem`. Cravado, a página PUBLICADA herdava o comportamento de
     edição — slots vazios apareciam e os cards deixavam de ser links (ver os
     usos de `isEditMode` em `View/CapaView`). */
  return (
    <AcompanheRedesSection
      data={data}
      isEditMode={!!onEditItem}
      onEditItem={onEditItem}
    />
  );
};

export default withBlockExtensions(MpfAcompanheRedesBlockView);
